import { __extends } from 'tslib';
import * as React from 'react';
import { throttle } from 'throttle-debounce';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-sticky.css';

var getClassNameList = classNames.bind(styles);
var THROTTLE_DELAY = 100;
var DEFAULT_HEIGHT = 'auto';
var DEFAULT_WIDTH = '100%';
var DEFAULT_ZINDEX = 1;
var UitkSticky = /** @class */ (function (_super) {
    __extends(UitkSticky, _super);
    function UitkSticky(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            fixed: false
        };
        _this.handleIntersection = _this.handleIntersection.bind(_this);
        _this.handleResize = throttle(THROTTLE_DELAY, false, _this.handleResize.bind(_this), false);
        _this.stickyRef = React.createRef();
        return _this;
    }
    UitkSticky.prototype.componentDidMount = function () {
        var options = {
            threshold: 1.0
        };
        if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(this.handleIntersection, options);
            this.observer.observe(this.stickyRef.current);
        }
        window.addEventListener('resize', this.handleResize);
    };
    UitkSticky.prototype.componentWillUnmount = function () {
        if (this.observer) {
            this.observer.unobserve(this.stickyRef.current);
        }
        window.removeEventListener('resize', this.handleResize);
    };
    UitkSticky.prototype.handleIntersection = function (entries) {
        var entry = entries.shift();
        this.setState({
            fixed: !entry || entry.boundingClientRect.top < 0,
            height: entry ? entry.boundingClientRect.height : DEFAULT_HEIGHT,
            width: entry ? entry.boundingClientRect.width : DEFAULT_WIDTH
        });
    };
    UitkSticky.prototype.handleResize = function () {
        if (this.stickyRef.current) {
            var _a = this.stickyRef.current.getBoundingClientRect(), height = _a.height, width = _a.width;
            this.setState({
                height: height,
                width: width
            });
        }
    };
    UitkSticky.prototype.render = function () {
        var _a, _b;
        var _c = this.state, fixed = _c.fixed, height = _c.height, width = _c.width;
        var _d = this.props, zIndex = _d.zIndex, hidden = _d.hidden, children = _d.children;
        var classes = getClassNameList(UitkSticky.baseClassName, (_a = {}, _a[UitkSticky.baseClassName + "-hidden"] = hidden, _a), (_b = {}, _b[UitkSticky.baseClassName + "-fixed"] = fixed, _b));
        var wrapperStyle = {
            // eslint-disable-next-line capitalized-comments
            height: hidden ? 0 : height /* stylelint-disable */
        };
        var innerStyle = {
            width: width,
            zIndex: zIndex || DEFAULT_ZINDEX
        };
        return (React.createElement("div", { ref: this.stickyRef, className: classes, style: wrapperStyle },
            React.createElement("div", { className: getClassNameList(UitkSticky.baseClassName + "-inner"), style: innerStyle }, children)));
    };
    UitkSticky.baseClassName = 'uitk-sticky';
    return UitkSticky;
}(React.PureComponent));

export { UitkSticky };
